import Pusher from 'pusher-js/with-encryption';
import Route from "./route";

async function initSoketi(wsHost, wsPort){
    try {
        const pusher = new Pusher('bi', {
            wsHost: wsHost,
            wssPort: wsPort,
            forceTLS: true,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
        });

        // LT listeners
        setupLiveTradeListeners(pusher);

    } catch (e) {
        console.error("Error:", e);
    }
}

function setupLiveTradeListeners(pusher) {
    const ltChannel = pusher.subscribe('LIVETRADE');

    ltChannel.bind_global((eventName, data) => {
        if (eventName === 'BID' || eventName === 'OFFER' || eventName === 'TRADE') {
            $("#market-listing").trigger("bi.refresh-row", {
                variantId: data.variantId,
                eventType: eventName
            });
        }
    });
}

$(function () {
    const wsRoutes = [
        "marketplace",
        "livetrade-plus",
        "tight-spreads",
        "watch-list"
    ];
    // initialise soketi ws
    if (wsRoutes.includes(Route) && $('#soketi-ws').length) {
        let wsHost = $('#soketi-ws').data('host');
        let wsPort = $('#soketi-ws').data('port');
        if (wsHost && wsPort) {
            initSoketi(wsHost, wsPort);
        }
    }
});
